// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"6e33eeb5","583":"3c3b9602"}[chunkId] + ".chunk.js";
};